export const SET_CONTACT_FIELDS_ACTION_NAME = "Set Contact Fields";

export const DEFAULT_SET_CONTACT_FIELDS_VALUE = { mode: "overwrite", entries: [] };

// Built-in fields this action can write. Phone number is intentionally absent: it is the
// contact's identity on the channel. Ids are matched by server setContactFields.service.js.
export const SETTABLE_CORE_FIELD_OPTIONS = [
  { _id: "core:name", name: "Name" },
  { _id: "core:email", name: "Email" },
  { _id: "core:businessName", name: "Business name" },
];

// Same definition the server seeds for WhatsApp (workflow.actionDefaults.js); Instagram, Facebook
// and Website drawers keep their action lists locally, so they reuse this one.
export const SET_CONTACT_FIELDS_ACTION = {
  name: SET_CONTACT_FIELDS_ACTION_NAME,
  description: "Saves values to the contact's fields (name, email, business name or your custom profile fields), either a fixed value or the customer's answer to a question. Overwrite the selected fields, or fill only the ones that are empty.",
  category: "Contact",
  config: [
    {
      name: "Set Contact Fields Node",
      required: true,
      fields: [{ label: "Configuration", type: "setContactFields", selectedValue: DEFAULT_SET_CONTACT_FIELDS_VALUE }],
    },
  ],
};

export const isSetContactFieldsAction = (name) => name === SET_CONTACT_FIELDS_ACTION_NAME;

const hasText = (v) => typeof v === "string" && v.trim() !== "";

export const isAskSource = (entry) => entry?.source === "ask";

/** Valid when at least one field is chosen and every fixed-value row has a value ("ask" rows need none). */
export const getSetContactFieldsError = (value) => {
  const entries = Array.isArray(value?.entries) ? value.entries : [];
  if (!entries.length) return "Add at least one field to set.";
  if (entries.some((e) => !e.fieldId)) return "Choose a field for every row.";
  if (entries.some((e) => !isAskSource(e) && !hasText(e.value))) return "Enter a value for every field, or switch it to ask the customer.";
  return null;
};

export const buildSetContactFieldsConfig = (configValue) => [
  {
    name: "Set Contact Fields Node",
    required: true,
    fields: [{ label: "Configuration", type: "setContactFields", selectedValue: configValue }],
  },
];
